package com.wintermar.inspection.core.ui.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.TextBodyRegular
import com.wintermar.inspection.core.ui.component.TextBodyTiny
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor

@Composable
fun CardInfo(
    label: String,
    value: String,
    modifier: Modifier = Modifier,
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension
) {
    Column(
        modifier = modifier
            .clip(RoundedCornerShape(dimension.radius.md))
            .background(color.surface.raised)
            .border(
                width = 1.dp,
                color = color.border.subtle,
                shape = RoundedCornerShape(dimension.radius.md)
            )
            .padding(dimension.spacing.space4),
        verticalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space1
        )
    ) {
        TextBodyTiny(
            text = label,
            color = { it.subtle }
        )

        TextBodyRegular(
            text = value,
            bold = true
        )
    }
}
